// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pain-card {
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
    max-width: 320px;
    font-family: Arial, sans-serif;
    border: 1px solid #ffb266; /* soft orange border */
  }
  
  .card-title {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 12px;
    color: #ff7b00; /* orange title */
  }
  
  .pain-row {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    margin: 6px 0;
  }
  
  .pain-value {
    color: #ff7b00; /* orange for values */
    font-weight: bold;
  }
  
  .divider {
    border: none;
    border-top: 1px solid #ffb266; /* light orange line */
    margin: 10px 0;
  }
  
  .overall-value {
    color: #d35400; /* darker orange for emphasis */
    font-weight: bold;
  }
  
  .monthly-target {
    font-size: 12px;
    color: #ff7b00;
    text-align: right;
    margin: 6px 0 0 0;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/pain-card/pain-card.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,gBAAgB;IAChB,8BAA8B;IAC9B,yBAAyB,EAAE,uBAAuB;EACpD;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc,EAAE,iBAAiB;EACnC;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,aAAa;EACf;;EAEA;IACE,cAAc,EAAE,sBAAsB;IACtC,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,6BAA6B,EAAE,sBAAsB;IACrD,cAAc;EAChB;;EAEA;IACE,cAAc,EAAE,+BAA+B;IAC/C,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,iBAAiB;EACnB","sourcesContent":[".pain-card {\n    border-radius: 12px;\n    padding: 16px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n    max-width: 320px;\n    font-family: Arial, sans-serif;\n    border: 1px solid #ffb266; /* soft orange border */\n  }\n  \n  .card-title {\n    font-size: 14px;\n    font-weight: bold;\n    margin-bottom: 12px;\n    color: #ff7b00; /* orange title */\n  }\n  \n  .pain-row {\n    display: flex;\n    justify-content: space-between;\n    font-size: 14px;\n    margin: 6px 0;\n  }\n  \n  .pain-value {\n    color: #ff7b00; /* orange for values */\n    font-weight: bold;\n  }\n  \n  .divider {\n    border: none;\n    border-top: 1px solid #ffb266; /* light orange line */\n    margin: 10px 0;\n  }\n  \n  .overall-value {\n    color: #d35400; /* darker orange for emphasis */\n    font-weight: bold;\n  }\n  \n  .monthly-target {\n    font-size: 12px;\n    color: #ff7b00;\n    text-align: right;\n    margin: 6px 0 0 0;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
